import React, { useEffect, useState } from "react";

//Material-ui / core
import { FormLabel, GridLegacy, Alert } from "@mui/material";

//Main components
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

//Variabelen
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import TranslatableEditor from "../../../components/TranslatableEditor/TranslatableEditor";
import FormCustomizableTextTC from "../../../components/Forms/FormCustomizableTextTC";
import Editor from "../../SunEditor";

function Berichten() {
  const { vestigingId } = useFormContext();
  const appTarget = useWatch({ name: "appTarget" });

  const [initSystemOfflineReason, setInitSystemOfflineReason] = useState(null);

  const {
    field: { value: extra_settings_id },
  } = useController({ name: "extra_settings__id" });
  const {
    field: { value: delivery_settings_id },
  } = useController({ name: "delivery_settings__id" });

  const {
    field: { value: systemOfflineReasonValue, onChange: systemOfflineReasonOnChange },
  } = useController({ name: "systemOfflineReason" });

  useEffect(() => {
    if (systemOfflineReasonValue !== null) {
      setInitSystemOfflineReason(systemOfflineReasonValue);
    } else {
      setInitSystemOfflineReason("");
    }
  }, [systemOfflineReasonValue]);

  let endpointParamsExtraSettings = { model_name: "extra_settings", id: extra_settings_id };
  let endpointParamsVestiging = { model_name: "vestiging", id: vestigingId };
  let endpointParamsDeliverySettings = { model_name: "delivery_settings", id: delivery_settings_id };

  const kioskOfflineImage = useWatch({ name: "extra_settings__kioskv5_background_of_home_page_closed" });
  const systemOfflineReason = useWatch({ name: "systemOfflineReason" });

  const shouldShowSystemOfflineAlert = kioskOfflineImage == null && systemOfflineReason == null;

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <FormFieldTwoColumns
            label={
              <FormLabel>
                <TranslationWrapper
                  tKey={"vestigingen.form.teksten.label.checkoutMessage"}
                  tDefault={"Message shown at checkout"}
                />
              </FormLabel>
            }
          >
            {endpointParamsExtraSettings.id == null ? (
              <>loading</>
            ) : (
              <TranslatableEditor contentName={"checkout_message"} endpointParams={endpointParamsExtraSettings} />
            )}
          </FormFieldTwoColumns>

          <FormCustomizableTextTC
            model={"vestiging"}
            modelId={vestigingId}
            tDefault={"Message shown at checkout"}
            tKey={"vestigingen.form.teksten.label.checkoutMessage"}
            translatableText={"checkout_message"}
          />
        </CardBody>
      </Card>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper
                  tDefault={"Uitgeschakeld meldtekst"}
                  tKey={"vestigingen.form.algemeen.label.systemOfflineReason"}
                />
              </h3>
            </GridLegacy>

            {appTarget?.includes("v5") ? (
              <>
                {shouldShowSystemOfflineAlert ? (
                  <Alert severity={"warning"}>
                    <p>
                      <TranslationWrapper
                        tDefault={
                          "With these settings, when your kiosk is offline no text will be shown to the customer. We recommend to either:"
                        }
                        tKey={"kiosk.system-offline.configuration-warning.intro"}
                      />
                    </p>
                    <ol>
                      <li>
                        <TranslationWrapper
                          tDefault={"Upload an image at kioskv5_background_of_home_page_closed"}
                          tKey={"kiosk.system-offline.configuration-warning.option1"}
                        />
                      </li>
                      <li>
                        <TranslationWrapper
                          tDefault={"Enable the default text"}
                          tKey={"kiosk.system-offline.configuration-warning.option2"}
                        />
                      </li>
                      <li>
                        <TranslationWrapper
                          tDefault={"Write text in the textfield below"}
                          tKey={"kiosk.system-offline.configuration-warning.option3"}
                        />
                      </li>
                    </ol>
                  </Alert>
                ) : null}

                {initSystemOfflineReason != null ? (
                  <FormFieldTwoColumns
                    label={
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Uitgeschakeld meldtekst"}
                          tKey={"vestigingen.form.algemeen.label.systemOfflineReason"}
                        />
                      </FormLabel>
                    }
                  >
                    <Editor
                      defaultValue={initSystemOfflineReason !== "" ? initSystemOfflineReason : ""}
                      onChange={systemOfflineReasonOnChange}
                      textareaName={"systemOfflineReason"}
                    />
                  </FormFieldTwoColumns>
                ) : null}
              </>
            ) : (
              <FormTextTC
                name={"systemOfflineReason"}
                tDefault={"Uitgeschakeld meldtekst"}
                tKey={"vestigingen.form.algemeen.label.systemOfflineReason"}
              />
            )}
          </GridLegacy>
        </CardBody>
      </Card>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Algemeen"} tKey={"vestigingen.form.berichten.headers.algemeen"} />
              </h3>
            </GridLegacy>

            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <FormFieldTwoColumns
                  label={
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Bericht"}
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__customerOrderMessage"}
                      />
                    </FormLabel>
                  }
                >
                  {endpointParamsDeliverySettings.id == null ? (
                    <>loading</>
                  ) : (
                    <TranslatableEditor
                      contentName={"customerOrderMessage"}
                      endpointParams={endpointParamsDeliverySettings}
                    />
                  )}
                </FormFieldTwoColumns>
              </CardBody>
            </Card>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <FormFieldTwoColumns>
                  <FormLabel>
                    <TranslationWrapper
                      tDefault={"Usable placeholder variables in text: "}
                      tKey={"vestigingen.form.berichten.label.orderMsg.placeholders"}
                    />
                    <div>
                      [id] , [oCnt] , [oCntShort] , [pickupNr] , [slotName] , [externOrderId] , [externTransId] ,
                      [tafelNr]
                    </div>
                  </FormLabel>
                </FormFieldTwoColumns>
                <FormFieldTwoColumns
                  label={
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Extra bericht order"}
                        tKey={"vestigingen.form.berichten.label.orderMsg"}
                      />
                    </FormLabel>
                  }
                >
                  {endpointParamsVestiging.id == null ? (
                    <>loading</>
                  ) : (
                    <TranslatableEditor contentName={"orderMsg"} endpointParams={endpointParamsVestiging} />
                  )}
                </FormFieldTwoColumns>
              </CardBody>
            </Card>
          </GridLegacy>
        </CardBody>
      </Card>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Sms teksten"} tKey={"vestigingen.form.berichten.headers.sms"} />
              </h3>
            </GridLegacy>
            <FormSwitchTC
              name={"extra_settings__sendSmsConfirmation"}
              tDefault={"Sent notification when order is accepted"}
              tKey={"vestigingen.form.overige.label.extra_settings__sendSmsConfirmation"}
            />
            <FormTextTC
              name={"extra_settings__smsConfirmationText"}
              tDefault={"Sms bericht voor ontvangst"}
              tKey={"vestigingen.form.berichten.label.smsConfirmationText"}
            />
            <FormTextTC
              name={"extra_settings__smsReadyText"}
              tDefault={"Sms bericht als de bestelling klaar is"}
              tKey={"vestigingen.form.berichten.label.smsReadyText"}
            />
            <FormTextTC
              name={"extra_settings__smsDeliveryText"}
              tDefault={"Sms bericht als bestelling is bezorgd"}
              tKey={"vestigingen.form.berichten.label.smsDeliveryText"}
            />
            <FormTextTC
              name={"extra_settings__smsFoodReadyText"}
              tDefault={"Sms bericht als het eten klaar is"}
              tKey={"vestigingen.form.berichten.label.smsFoodReadyText"}
            />
            <FormTextTC
              name={"extra_settings__smsDrinksReadyText"}
              tDefault={"Sms bericht als het drinken klaar is"}
              tKey={"vestigingen.form.berichten.label.smsDrinksReadyText"}
            />
            <FormSwitchTC
              default={false}
              name={"custom_data.sms.after_order"}
              tDefault={"Send text message after order"}
              tKey={"custom_data.sms.after_order"}
            />
            <FormTextTC
              name={"custom_data.sms.target_number"}
              tDefault={"Phone number"}
              tKey={"custom_data.sms.target_number"}
            />
            <FormFieldTwoColumns>
              <FormLabel>
                <TranslationWrapper
                  tDefault={"Usable placeholder variables in text: "}
                  tKey={"vestigingen.form.berichten.label.orderMsg.placeholders"}
                />
                <div>[id] , [oCnt] , [oCntShort] , [pickupNr], [tableId], [tableName], [orderUrl]</div>
              </FormLabel>
            </FormFieldTwoColumns>
            <FormTextTC
              name={"custom_data.sms.after_order_text"}
              tDefault={"Sms message"}
              tKey={"custom_data.sms.after_order_text"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Infoscherm"} tKey={"vestigingen.form.berichten.headers.infoScreen"} />
              </h3>
            </GridLegacy>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <FormSwitchTC
                  name={"extra_settings__showNoSlots"}
                  tDefault={"Show no free slots info"}
                  tKey={"vestigingen.form.overige.label.extra_settings__showNoSlots"}
                />
                <FormFieldTwoColumns
                  label={
                    <FormLabel>
                      <TranslationWrapper tKey={"Info Screen no free slots"} />
                    </FormLabel>
                  }
                >
                  {endpointParamsExtraSettings.id == null ? (
                    <>loading</>
                  ) : (
                    <TranslatableEditor contentName={"noSlotsContent"} endpointParams={endpointParamsExtraSettings} />
                  )}
                </FormFieldTwoColumns>
              </CardBody>
            </Card>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <FormFieldTwoColumns
                  label={
                    <FormLabel>
                      <TranslationWrapper tKey={"Table product required"} />
                    </FormLabel>
                  }
                >
                  {endpointParamsExtraSettings.id == null ? (
                    <>loading</>
                  ) : (
                    <TranslatableEditor
                      contentName={"tableProductRequiredTxt"}
                      endpointParams={endpointParamsExtraSettings}
                    />
                  )}
                </FormFieldTwoColumns>
              </CardBody>
            </Card>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <FormFieldTwoColumns
                  label={
                    <FormLabel>
                      <TranslationWrapper tKey={"POS Communication error message"} />
                    </FormLabel>
                  }
                >
                  {endpointParamsExtraSettings.id == null ? (
                    <>loading</>
                  ) : (
                    <TranslatableEditor contentName={"posIssueTxt"} endpointParams={endpointParamsExtraSettings} />
                  )}
                </FormFieldTwoColumns>
              </CardBody>
            </Card>
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Berichten;
